module.exports = __webpack_public_path__ + "img/1_2.c0097668.png";